import uuid from "uuid/v1";
import {
  createAppliedPriceTriggerPart,
  createItemAppliedPriceTriggerPart
} from "../helpers/priceTriggerHelpers";

function CreatOrderItemObj(item, priceTriggers) {
  var productTotalTax = 0;
  var productTotalPrice = 0;
  var productTax = fix2digit(
    computeTax({
      price: item.price,
      taxRate: item.tax
    })
  );
  productTotalTax += productTax;
  productTotalPrice += item.price;
  let orderitem = {
    CreatedOn: new Date().toUTCString(),
    DisplayingOrder: 0,
    FinalTotalExcludingTax: 0,
    FinalTotalTax: 0,
    ModifyingExcludingTax: 0,
    ModifyingTax: 0,
    Name: item.name,
    Note: item.itemNote,
    OrderExtras: [],
    Product_ID: item.id,
    Quantity: item.quantity,
    Timestamps: [],
    UDID: uuid(),
    UsingTaxRate: item.tax,
    UsingUnitPrice: item.price,
    uniqueId: item.uniqueId
  };

  if (item.modifiers) {
    for (var md of item.modifiers) {
      var mdQuantity = md.quantity;
      var mdTaxRate = md.TaxRate ? md.TaxRate : item.tax;
      var mdTax = fix2digit(
        computeTax({
          price: md.Price,
          taxRate: mdTaxRate
        })
      );
      var mdPriceExcludingTax = md.Price - mdTax;
      var extra = {
        DisplayingOrder: md.DisplayOrder,
        Extra_ID: md.ID,
        FinalPriceExcludingTax: mdPriceExcludingTax,
        FinalTax: mdTax,
        Name: md.Name,
        Quantity: mdQuantity,
        UDID: uuid(),
        UsingUnitPrice: md.Price
      };
      if (md.selectedSubmodifiers) {
        extra.ChildrenOrderExtras = [];
        for (var sub of md.selectedSubmodifiers) {
          var subQuantity = sub.quantity;
          var subTaxRate = sub.TaxRate ? sub.TaxRate : item.tax;
          var subTax = fix2digit(
            computeTax({
              price: sub.Price,
              taxRate: subTaxRate
            })
          );
          var subPriceExcludingTax = sub.Price - subTax;
          var subextra = {
            DisplayingOrder: sub.DisplayOrder,
            Extra_ID: sub.ID,
            FinalPriceExcludingTax: subPriceExcludingTax,
            FinalTax: subTax,
            Name: sub.Name,
            Quantity: subQuantity,
            UDID: uuid(),
            UsingUnitPrice: sub.Price
          };
          extra.ChildrenOrderExtras.push(subextra);
          productTotalTax += subTax * subQuantity;
          productTotalPrice += sub.Price;
        }
      }
      orderitem.OrderExtras.push(extra);
      productTotalTax += mdTax * mdQuantity;
      productTotalPrice += md.Price;
    }
  }
  productTotalTax = productTotalTax * item.quantity;
  productTotalPrice = productTotalPrice * item.quantity;
  orderitem["FinalTotalTax"] = fix2digit(productTotalTax);
  orderitem["FinalTotalExcludingTax"] = productTotalPrice - productTotalTax;
  orderitem.AppliedPriceTriggerRecords = createItemAppliedPriceTriggerPart(
    orderitem,
    priceTriggers
  );
  return orderitem;
}

function createOrderItem(item, priceTriggers) {
  var orderitem = CreatOrderItemObj(item, priceTriggers);
  return orderitem;
}
export function CreateOrderObject(
  cartState,
  priceItem,
  user,
  resturant,
  card,
  guid,
  orderInfo,
  guestUserId,
  priceTriggers
) {
  let orderItems = [];
  let totalTax = fix2digit(priceItem.totalTax);
  let totalAmount = fix2digit(priceItem.totalPrice);
  let deliveryFee = cartState.isDelivery ? cartState.deliveryFee : 0;
  let freightTax = 0;
  let freightExcludingTax = cartState.isDelivery ? deliveryFee - freightTax : 0;
  for (var i = 0; i < cartState.cartItems.length; i++) {
    var item = cartState.cartItems[i];
    var orderitem = createOrderItem(item, priceTriggers);
    orderItems.push(orderitem);
  }

  if (priceItem.freeOrderItems) {
    for (i = 0; i < priceItem.freeOrderItems.length; i++) {
      item = priceItem.freeOrderItems[i];
      orderitem = createOrderItem(item, priceTriggers);
      orderItems.push(orderitem);
    }
  }

  var SubTotalAmount = priceItem.subTotalPrice;
  let model = {
    BankCardSurcharge: 0,
    CallbackUrlOnOrderAcceptance: "",
    ContactCustomer_Contact_Number: user.Phone,
    ContactCustomer_DisplayName: user.DisplayName,
    ContactCustomer_Email_Address: user.Email,
    CreatedOn: new Date().toUTCString(),
    CustomerMemberCode: "",
    DiscountExcludingTax: priceItem.discountExcludingTax,
    DiscountTax: priceItem.discountTax,
    FreightExcludingTax: freightExcludingTax,
    FreightTax: freightTax,
    GuestUserIdentifier: user.IsGuest ? guestUserId : "",
    InvoiceNumber: "",
    OrderNote: orderInfo.notes,
    OrderNumber: null,
    OnlineOrderStatus: 1,
    OnlineOrderStatusDescription: "",
    OnlineOrderUserIdentifier: user.IsGuest ? "" : user.ID,
    OrderItems: orderItems,
    DeliveryAddress: orderInfo.DeliveryAddress,
    OrderType: orderInfo.orderType,
    PaymentTransactions: [
      {
        Amount: totalAmount
      }
    ],
    PaymentReferences: null,
    POSSurchargeExcludingTax: 0,
    POSSurchargeTax: 0,
    PaymentCardIdentifier: card.isToken ? card.token : "",
    ScheduledTime: orderInfo.scheduledTime,
    StoreID: resturant.ID,
    StoreName: resturant.Name,
    SubtotalExcludingTax: SubTotalAmount - totalTax,
    SubtotalTax: totalTax,
    Source: "",
    SourceReference_ID: "",
    Timestamps: [],
    TotalExcludingTax: fix2digit(totalAmount - totalTax),
    TotalTax: totalTax,
    UDID: guid,
    AppliedPriceTriggerRecords: createAppliedPriceTriggerPart(
      orderItems,
      priceTriggers
    )
  };
  return model;
}
export function CreateGiftOrderObject(
  cartState,
  cartValue,
  user,
  resturant,
  card,
  guid,
  orderInfo
) {
  let orderItems = [];
  let totalTax = 0;
  let totalAmount = 0;
  let deliveryFee = cartState.isDelivery ? cartState.deliveryFee : 0;
  let freightTax = 0;
  let freightExcludingTax = deliveryFee - freightTax;
  for (var i = 0; i < cartState.cartItems.length; i++) {
    var item = cartState.cartItems[i];
    var itemTaxAmount = 0;
    var itemPriceWithoutTax = item.price - itemTaxAmount;
    totalAmount += item.price * item.quantity;
    totalTax += itemTaxAmount * item.quantity;
    var orderitem = {
      CreatedOn: new Date().toUTCString(),
      DisplayingOrder: 0,
      FinalTotalExcludingTax: 0,
      FinalTotalTax: 0,
      ModifyingExcludingTax: 0,
      ModifyingTax: 0,
      Name: item.name,
      OrderExtras: [],
      Product_ID: item.id,
      Quantity: item.quantity,
      Timestamps: [],
      UDID: uuid(),
      UsingTaxRate: item.tax,
      UsingUnitPrice: item.price,
      AdditionalDataType: "GiftCardDetailType",
      AdditionalData: {
        FromName: item.message.From,
        ToName: item.message.To,
        ToEmail: item.message.Email,
        Message: item.message.Message
      }
    };
    orderitem["FinalTotalTax"] = itemTaxAmount * item.quantity;
    orderitem["FinalTotalExcludingTax"] = itemPriceWithoutTax * item.quantity;
    orderItems.push(orderitem);
  }
  var SubTotalAmount = totalAmount;
  //delivery price and tax
  totalAmount += deliveryFee;
  totalTax += freightTax;
  let model = {
    BankCardSurcharge: 0,
    CallbackUrlOnOrderAcceptance: "",
    ContactCustomer_Contact_Number: user.Phone,
    ContactCustomer_DisplayName: user.DisplayName,
    ContactCustomer_Email_Address: user.Email,
    CreatedOn: new Date().toUTCString(),
    CustomerMemberCode: "",
    DiscountExcludingTax: 0,
    DiscountTax: 0,
    FreightExcludingTax: freightExcludingTax,
    FreightTax: freightTax,
    GuestUserIdentifier: user.IsGuest ? uuid() : "",
    InvoiceNumber: "",
    OrderNumber: null,
    IsLiability: true,
    OnlineOrderStatus: 1,
    OnlineOrderStatusDescription: "",
    OnlineOrderUserIdentifier: user.IsGuest ? "" : user.ID,
    OrderItems: orderItems,
    DeliveryAddress: orderInfo.DeliveryAddress,
    OrderType: orderInfo.orderType,
    PaymentTransactions: [
      {
        Amount: totalAmount
      }
    ],
    PaymentReferences: null,
    POSSurchargeExcludingTax: 0,
    POSSurchargeTax: 0,
    PaymentCardIdentifier: card.isToken ? card.token : "",
    ScheduledTime: orderInfo.scheduledTime,
    StoreID: resturant.ID,
    StoreName: resturant.Name,
    SubtotalExcludingTax: SubTotalAmount - totalTax,
    SubtotalTax: totalTax,
    Source: "",
    SourceReference_ID: "",
    Timestamps: [],
    TotalExcludingTax: totalAmount - totalTax,
    TotalTax: totalTax,
    UDID: guid
  };
  return model;
}
export function fix2digit(value) {
  return Number(parseFloat(value).toFixed(2));
}

export function computeTax(item) {
  return item.price - (item.price * 100) / (item.taxRate * 100 + 100);
}
export function DiscountTax(totalTax, cartValue, discount) {
  var shopTaxRate = totalTax / cartValue; //tax rate is not always 10% so we use this to caluclate total tax percentage for the cart
  var discountValueTax = shopTaxRate * discount;
  return fix2digit(discountValueTax);
}
export function positive(val) {
  return val < 0 ? 0 : val;
}
export function TotalTaxExcludingDicountTax(cartItems) {
  let totalTax = 0;
  let freightTax = 0;
  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];
    var itemTaxAmount = fix2digit(
      computeTax({
        price: item.price,
        taxRate: item.tax
      })
    );
    totalTax += itemTaxAmount * item.quantity;

    for (var j = 0; j < item.modifiers.length; j++) {
      var md = item.modifiers[j];
      var quantity = item.modifiers[j].quantity;
      var mdTaxRate = md.TaxRate ? md.TaxRate : item.tax;
      var mdTax = fix2digit(
        computeTax({
          price: md.Price,
          taxRate: mdTaxRate
        })
      );
      totalTax += mdTax * quantity * item.quantity;
    }
  }
  //delivery price and tax
  totalTax += freightTax;
  return fix2digit(totalTax);
}
export function TotalTax(cartItems, cartValue, discount) {
  let totalTax = TotalTaxExcludingDicountTax(cartItems);
  totalTax -= DiscountTax(totalTax, cartValue, discount);
  return fix2digit(totalTax);
}
